import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6bd25921"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "divider-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass(['node-container', 'divider-container', _ctx.rowTypeClass, _ctx.blockWidthClass, _ctx.dividerPadding])
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("hr", {
                    class: _normalizeClass(["divider", _ctx.dividerType])
                }, null, 2)
            ])
        ]),
        _: 1
    }, 8, ["class"]));
}
